import script from "./ListarPedidos.vue?vue&type=script&setup=true&lang=js"
export * from "./ListarPedidos.vue?vue&type=script&setup=true&lang=js"

import "@/assets/plantilla/style.css?vue&type=style&index=0&id=1fcc9c42&scoped=true&lang=css"
import "./ListarPedidos.vue?vue&type=style&index=1&id=1fcc9c42&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fcc9c42"]])

export default __exports__